import { makeStyles } from "tss-react/mui"
import { Box, Typography } from "@mui/material"
import { LocalizedStrict } from "../../../../localization/components/AppLocalized"
import { useDateTime } from "../../../../localization/useDateTime"
import { EntityHistory } from "../supportEntitiesTypes"

const useStyles = makeStyles()(() => ({
    historyContainer: {
        display: "flex",
        flexDirection: "column",
        gap: "2rem",
    },
    infoBox: {
        display: "flex",
        justifyContent: "space-between",
    },
}))

export function EntityHistoryAccordion({ history }: { history: EntityHistory }) {
    const { classes } = useStyles()
    const dateTimeFactory = useDateTime()

    const { created, updated } = history

    return (
        <Box className={classes.historyContainer}>
            <Box className={classes.infoBox}>
                <LocalizedStrict id="support-create-entity-aside-created">
                    <Typography>Created: </Typography>
                </LocalizedStrict>
                <Box>
                    <Typography textAlign="right">
                        {dateTimeFactory.formatDate(dateTimeFactory.fromISO(created.timestamp))}
                    </Typography>
                    <Typography textAlign="right">{created.author}</Typography>
                </Box>
            </Box>
            <Box className={classes.infoBox}>
                <LocalizedStrict id="support-create-entity-aside-updated">
                    <Typography>Updated: </Typography>
                </LocalizedStrict>
                <Box>
                    <Typography textAlign="right">
                        {dateTimeFactory.formatDate(dateTimeFactory.fromISO(updated.timestamp))}
                    </Typography>
                    <Typography textAlign="right">{updated.author}</Typography>
                </Box>
            </Box>
        </Box>
    )
}
